import type { AuditorNoteAttributes, UserAttributes } from '@/server/models'

import { SQL, type SQLFragment } from '@/client/query'

import {
  type AssociationDefinitions,
  type GroupBy,
  type IncludeAssociations,
  includeAssociationsToSql,
  makeQueryModelV2,
  type QueryOrder,
  queryGroupByToSQL,
  queryOrderToSQL,
} from './common'
import UserQ from './UserQ'

const AuditorNoteQ = {
  ...makeQueryModelV2<AuditorNoteAttributes>('auditor_note')([
    'id',
    'user_id',
    'subject_user_id',
    'note',
    'new_auditor_level',
    'created_at',
  ]),

  associations: (): AssociationDefinitions => ({
    User: {
      query: UserQ,
      foreignKey: UserQ.id,
      sourceKey: AuditorNoteQ.user_id,
    },
  }),

  where: (
    {
      subjectUserId,
      include = [],
      groupBy = null,
      order = null,
    }: {
      subjectUserId?: number | null | SQLFragment<number>
      include?: IncludeAssociations
      groupBy?: GroupBy | null
      order?: QueryOrder | null
    },
    customWhere: SQLFragment<unknown> | null = null
  ): SQLFragment<AuditorNoteAttributes> => SQL`
        FROM ${AuditorNoteQ}
        ${includeAssociationsToSql(AuditorNoteQ, include)}
        WHERE
            ${
              subjectUserId != null
                ? SQL`${AuditorNoteQ.subject_user_id} = ${subjectUserId} AND`
                : SQL``
            }
            ${customWhere != null ? customWhere : SQL`TRUE`}
        ${queryGroupByToSQL(groupBy)}
        ${queryOrderToSQL(order)}
    `,

  getUser: (): SQLFragment<UserAttributes> =>
    UserQ.where({
      id: AuditorNoteQ.user_id,
    }),

  getSubject: (): SQLFragment<UserAttributes> =>
    UserQ.where({
      id: AuditorNoteQ.subject_user_id,
    }),
}

export default AuditorNoteQ
